const Create = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Orders/Create')
const Edit = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Orders/Edit')
const Print = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Orders/Print')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Orders/Search')

export default [
  {
    path: 'orders/create',
    name: 'OrdersCreate',
    component: Create,
    meta: {
      title: 'Abrir Ordem de Serviço',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'orders',
        action: 'create'
      }
    }
  },
  {
    path: 'orders/:id',
    name: 'OrdersEdit',
    component: Edit,
    meta: {
      title: 'Editar Ordem de Serviço',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'orders',
        action: 'read'
      }
    }
  },
  {
    path: 'orders/:id/print',
    name: 'OrdersPrint',
    component: Print,
    meta: {
      title: 'Imprimir Ordem de Serviço',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'orders',
        action: 'read'
      }
    }
  },
  {
    path: 'orders',
    name: 'OrdersSearch',
    component: Search,
    meta: {
      title: 'Ordens de Serviço',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'orders',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/orders.js